// import { applyMiddleware, compose, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducers';
import rootSaga from './sagas';
import { configureStore } from '@reduxjs/toolkit';

// Import your slices here
// import exampleSlice from './slices/exampleSlice';

const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
  key: 'root',
  storage
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default function configureAppStore(initialState) {

  // const middleware = [sagaMiddleware];
  // const composeEnhancers =
  //   window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  // const store = createStore(
  //   persistedReducer,
  //   initialState,
  //   composeEnhancers(applyMiddleware(...middleware))
  // );
  // const persistor = persistStore(store);
  // sagaMiddleware.run(rootSaga);
  const store = configureStore({
    reducer: persistedReducer, // persistedReducer'ı kullanıyoruz
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: true, // Thunk kullanmıyoruz, saga kullanıldığı için false
        serializableCheck: false, // persist için serializable check'i devre dışı bırakıyoruz
      }).concat(sagaMiddleware), // Saga middleware'i ekliyoruz
    preloadedState: initialState, // Initial state ekliyoruz
    devTools: process.env.NODE_ENV !== 'production', // DevTools'u sadece development ortamında açıyoruz
  });

  // Saga'ları çalıştır
  sagaMiddleware.run(rootSaga);

  // Persistor'u oluştur
  const persistor = persistStore(store);

  return { store, persistor };
}
export const store = configureAppStore().store;